import { ReactComponent as Logo } from '../assets/images/logo.svg';
import { ReactComponent as SignInImage } from '../assets/images/signIn.svg';
import { ReactComponent as SignUpImage } from '../assets/images/signUp.svg';

export default {
    Logo,
    SignInImage,
    SignUpImage,
};
